import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { Grid } from './Grid';
import { generateWordSearch, DIRECTIONS_ALL, DIRECTIONS_SIMPLE, } from '../../utils/word-search';
export const WordBox = ({ randomiseGrid, words, onUpdate, onCancel, }) => {
    const [validationMessage, setValidationMessage] = useState('');
    const [text, setText] = useState(words
        ? words
            .map((word) => `${word.answer.toUpperCase()} ${word.clue}`)
            .join('\n')
        : '');
    const [wordList, setWordList] = useState(words ?? []);
    const [grid, setGrid] = useState(null);
    // Diagonals + reversed words when the grid is randomised, otherwise a plain
    // across/down layout.
    const directions = randomiseGrid ? DIRECTIONS_ALL : DIRECTIONS_SIMPLE;
    // Rebuild the preview grid whenever the parsed word list (or direction set)
    // changes.
    useEffect(() => {
        if (wordList.length > 0) {
            setGrid(generateWordSearch(wordList.map((w) => w.answer), { directions }));
        }
        else {
            setGrid(null);
        }
        // `directions` is derived from `randomiseGrid`, so depend on that.
    }, [wordList, randomiseGrid]);
    const handleRegenerateGrid = () => {
        if (wordList.length > 0) {
            setGrid(generateWordSearch(wordList.map((w) => w.answer), { directions }));
        }
    };
    function getWordsFromText(value) {
        const answerList = [];
        const parsedWords = [];
        const lines = value.trim().replace(/\n+/g, '\n');
        lines.split('\n').forEach((line) => {
            line = line.trim().replace(/\n+/g, '\n');
            const parts = line.split(' ');
            if (parts.length > 1) {
                answerList.push(parts[0]);
                parsedWords.push({
                    answer: parts[0].trim().replace(/\s+/g, ''),
                    clue: line.substring(parts[0].length).trim().replace(/\s+/g, ' '),
                });
            }
        });
        return { answerList, parsedWords };
    }
    const handleTextChange = (e) => {
        setValidationMessage('');
        const value = e.target.value;
        setText(value);
        const lineRegex = /^([a-zA-Z]+)\s+([\w\W]+)$/gm;
        if (lineRegex.test(value)) {
            const { parsedWords } = getWordsFromText(value);
            setWordList(parsedWords);
        }
    };
    const handleWordsSubmit = () => {
        if (!text || text.trim() === '') {
            setValidationMessage('Cannot be empty');
            return;
        }
        const lineRegex = /^([a-zA-Z]+)\s+([\w\W]+)$/gm;
        if (!lineRegex.test(text)) {
            setValidationMessage('Enter each word followed by its clue, one per line');
            return;
        }
        const { parsedWords } = getWordsFromText(text);
        if (parsedWords.length === 0) {
            setValidationMessage('Add at least one word and clue');
            return;
        }
        onUpdate(parsedWords);
    };
    return (React.createElement("div", { className: "word-form__container" },
        React.createElement("p", { className: "validation-message" }, validationMessage),
        React.createElement("div", { className: "word-form__content" },
            React.createElement("textarea", { className: "word-form__textarea", value: text, onChange: handleTextChange, placeholder: 'ANSWER1 Clue1\nANSWER2 Clue2', rows: 10, onFocus: () => setValidationMessage('') }),
            React.createElement("div", { className: "word-form__grid-controls" },
                React.createElement("button", { className: "btn--primary", onClick: handleRegenerateGrid, title: "Regenerate grid layout", type: "button" },
                    React.createElement(FontAwesomeIcon, { icon: faArrowsRotate }))),
            grid && (React.createElement("div", { className: "word-form__grid-container" },
                React.createElement(Grid, { cells: grid.cells, size: grid.size })))),
        React.createElement("div", { className: "word-form__controls" },
            React.createElement("button", { className: "btn--primary", onClick: handleWordsSubmit, type: "button" }, "Submit"),
            React.createElement("button", { className: "btn--secondary", onClick: () => {
                    onCancel();
                }, type: "button" }, "Cancel"))));
};
